
var CloudPaymentsService = (function () {

    'use strict';


    function init() {

    }
    //************ Public ************//
    return {
        init: init
    };
})();

$(CloudPaymentsService.init);


